/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component, PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './strategieWeb.css';
import Helmet from 'react-helmet';
import fetch from '../../core/fetch';
import { Link } from 'react-router';

const title = 'Stratégie web';

@withStyles(s)
export default class StrategieWeb extends Component {
    
	constructor(props) {
        super(props);

        this.state = {
            strategieWeb: [],
            loader: true,
        };

        
    }

    componentDidMount(){

        this.GetStrategieWeb();

    }

    async GetStrategieWeb(){
        const resp = await fetch('/graphql', {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: '{strategieWeb{id, slug, title, content, titreBanniere, schemaLeft, schemaRight, sectionPourquoi, sectionServices}}',
            }),
            credentials: 'include',
        });
        
        const { data } = await resp.json();
        if (!data || !data.strategieWeb) throw new Error('Erreur sur le chargement de la page strategie web !');

        if(data){
            this.setState({ loader: false })
        }
        
        this.setState({ strategieWeb: data.strategieWeb })
    }

    render(){

        const topLink = <div className={`topLink`}>
                           <div className={`container`}>
                              <div className={`autreServices`}>
                                 <span>Nos autres services:</span>
                                 <ul>
                                    <li><Link to="/service-conseil">Accompagnement</Link></li>
                                    <li><Link to="/developpement-web">Développement Web</Link></li>
                                 </ul>
                              </div>
                           </div>
                        </div>;

        const titreBanniere = <div dangerouslySetInnerHTML={{ __html: this.state.strategieWeb.titreBanniere }} />;
        const topContent = <div dangerouslySetInnerHTML={{ __html: this.state.strategieWeb.content }} />;
        const schemaLeft = <div dangerouslySetInnerHTML={{ __html: this.state.strategieWeb.schemaLeft }} />;
        const schemaRight = <div dangerouslySetInnerHTML={{ __html: this.state.strategieWeb.schemaRight }} />;
        const sectionPourquoi = <div dangerouslySetInnerHTML={{ __html: this.state.strategieWeb.sectionPourquoi }} />;
        const sectionServices = <div dangerouslySetInnerHTML={{ __html: this.state.strategieWeb.sectionServices }} />;
        
        const appear = this.state.loader ? 'appear' : '';

        var background = {
            backgroundColor: '#008eef'
        }

        return (
	        <div className={s.root}>
	            <Helmet title={title} meta={[{"name": "description", "content": "Stratégie Web, Planification Stratégique, Plan marketing web, Période Test, Lancement, Optimisation"}]}/>
                <div className={`spinner ${appear}`} style={background}></div>
	            <div id="strategieWeb" className={`strategieWeb`}>
                    <div className={`bgExpertise`}>
                        <div className={`container`}>
                            <div className={`content`}>
                                <h1 className={`titrePage`}>{titreBanniere}</h1>
                            </div>
                        </div>
                    </div>
                    <main role="main">
                        {topLink}
                        {topContent}
                        <div className={`sectionSchema`}>
                            <div className={`wrapSchema`}>
                                <div className={`container`}>
                                    <div className={`leftCol`}>
                                        <div className={`content`}>
                                            {schemaLeft}
                                        </div>
                                    </div>
                                    <div className={`centerCol`}>
                                        <div className={`imageSchema`}></div>
                                    </div>
                                    <div className={`rightCol`}>
                                        <div className={`content`}>
                                            {schemaRight}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`sectionPourquoi`}>
                            <span className={`smallTitle`}>Pourquoi choisir</span>
                            <h1 className={`titrePage`}>Prolifik ?</h1>
                            <div className={`circleLine`}>
                                <div className={`circle`}></div>
                                <div className={`line`}></div>
                                <div className={`circle`}></div>
                                <div className={`line`}></div>
                                <div className={`circle`}></div>
                                <div className={`line`}></div>
                                <div className={`circle`}></div>
                            </div>
                            <div className={`pourquoiListe`}>
                                <div className={`container`}>
                                    {sectionPourquoi}
                                </div>
                            </div>
                        </div>
                        <div className={`sectionServices`}>
                            <div className={`container`}>
                                <span className={`smallTitle`}>Nos</span>
                                <h1 className={`titrePage`}>Services</h1>
                                <div className={`wrapServices`}>
                                    {sectionServices}
                                </div>
                            </div> 
                        </div>
                        <div className={`container`}>
                            <div className={`bottomContact`}>
                                <div className={`w50`}>
                                    <span className={`smallTitle`}>Vous désirez</span>
                                    <h1 className={`titrePage`}>Faire des ventes</h1>
                                    <span className={`smallTitle`}>grâce au web</span>
                                </div>
                                <div className={`w50`}>
                                    <div className={`btnSite`}>
                                        <Link to="/contact">Contactez-nous dès maintenant!</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
	    );
    }
}





// WEBPACK FOOTER //
// ./containers/strategieWeb/strategieWeb.js